<template>
    <div class="tableBox">
        <!-- <table>
            <tbody>
            <tr>
                <th :rowspan="2">目标职业</th>
                <td>目标职业类：{{plan.targetCareerField}}</td>
            </tr>
            <tr>
                <td>目标职业：
                    <template v-if="plan.targetCareer">
                        <span v-for="(value,index) in plan.targetCareer">{{index !=0 ?'、':''}}{{value}}</span>
                    </template>
                </td>
            </tr>
            <tr>
                <th :rowspan="2">目标专业</th>
                <td>目标专业类：{{plan.professional}}</td>
            </tr>
            <tr>
                <td>
                    目标专业：
                    <template v-if="plan.targetSubject">
                        <span v-for="(value,index) in plan.targetSubject">{{index !=0 ?'、':''}}{{value}}</span>
                    </template>
                </td>
            </tr>
            <tr>
                <th>目标院校</th>
                <td>
                    <template v-if="plan.universityIdName">
                        <span v-for="(value,index) in plan.universityIdName">{{index !=0 ?'、':''}}{{value.name}}</span>
                    </template>
                </td>
            </tr>
            <tr>
                <th>目标分数</th>
                <td>
                    {{plan.score}} / {{plan.rank}}
                </td>
            </tr>
            <tr>
                <th :rowspan="3" >目标路径</th>
                <td>升学路径：{{plan.furtherWay}}</td>
            </tr>
            <tr>
                <td><p>路径条件：{{plan.furtherWayNeed}}</p></td>
            </tr>
            <tr>
                <td><p>其他条件：{{plan.furtherWayNeedOther}}</p></td>
            </tr>
            <tr>
                <th>目标选科</th>
                <td>

                    <template v-if="plan.chooseSubjectName">
                        <span v-for="(value,index) in plan.chooseSubjectName">{{index !=0 ?'、':''}}{{value}}</span>
                    </template>
                </td>
            </tr>
            </tbody>
        </table> -->
         <table>
            <tbody>
            <tr>
              
                <th rowSpan="2">目标职业</th>
                <td>{{version==1?'目标职业领域':'目标职业类'}}：{{plan.targetCareerField}}</td>
            </tr>
             <tr>
                <td>目标职业：
                    <template >
                        <span v-for="(item,index) in plan.targetCareer" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                    </span>
                    </template>
                </td>
            </tr>
            <tr>
                <th :rowspan="2">目标专业</th>
                <td v-if="version==2||version==0">目标专业类：{{plan.professional}}</td>
            </tr>
             <tr>
                <td>目标专业：
                    <template>
                        <span v-for="(item,index) in plan.targetSubject" :key="index">
                            <template v-if="index>0">、</template>
                            {{item}}
                        </span>
                    </template>
                </td>
            </tr>
            <tr>
                <th>目标院校</th>
                <td>
                    <template v-if="plan.universityIdName">
                        <span v-for="(value,index) in plan.universityIdName">{{index !=0 ?'、':''}}{{value.name}}</span>
                    </template>
                </td>
            </tr>
            <tr>
                <th>目标分数</th>
                <td>
                    {{plan.score}} / {{plan.rank}}
                </td>
            </tr>
            <tr>
                <th :rowspan="3" >目标路径</th>
                <td>升学路径：{{plan.furtherWay}}</td>
            </tr>
            <tr>
                <td><p>路径条件：{{plan.furtherWayNeed}}</p></td>
            </tr>
            <tr>
                <td><p>其他条件：{{plan.furtherWayNeedOther}}</p></td>
            </tr>
            <tr>
                <th>目标选科</th>
                <td>

                    <template v-if="plan.chooseSubjectName">
                        <span v-for="(value,index) in plan.chooseSubjectName">{{index !=0 ?'、':''}}{{value}}</span>
                    </template>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: ['plan','version',],
    name: 'planTable',
    components: {
    },
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
.tableBox {
    table {
        width: 100%;
    }
    tbody {
        font-size: 16px;
        tr {
            line-height: 40px;
            th {
                font-weight: bold;
                text-align: center;
                width: 148px;
                background: #E5F2F9;
                border: 1px solid #29AAF4;
                color: #29AAF4;
                font-weight: bold;
            }
            td {
                padding-left: 20px;
                padding-right: 20px;
                border: 1px solid #29AAF4;
                background-color: #F3FAFB;
                font-size: 15px;
                p {
                    padding: 5px 0;
                    line-height: 26px;
                }
            }
        }
    }
}

</style>